import { render, staticRenderFns } from "./ideaForm.vue?vue&type=template&id=5e9cb572&"
import script from "./ideaForm.vue?vue&type=script&lang=js&"
export * from "./ideaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports